import { TruncatingText } from '#UNSAFE_TruncatingText';
import { classNames } from '#utils/UNSAFE_classNames';
import { styles } from './themes/RichSelectionItemStyles.css';

type RichSelectionTextContentProps = {
  secondaryTextId?: string;
  label?: string;
  secondaryText?: string;
  isDisabled?: boolean;
  // INFO: label truncates for 1 line in only XL
  isLayoutXL?: boolean;
  labelId: string;
};

// INFO: Label and SecondaryText Content handling
export const RichSelectionTextContent = ({
  secondaryTextId,
  isDisabled,
  isLayoutXL,
  label,
  labelId,
  secondaryText
}: RichSelectionTextContentProps) => {
  const labelContent = (
    <TruncatingText
      variant={isDisabled ? 'disabled' : 'primary'}
      lineClamp={isLayoutXL ? 1 : 2}
      id={labelId}>
      {label}
    </TruncatingText>
  );
  const classes = classNames([
    isLayoutXL ? styles.densityWrapper : styles.growOneColumn,
    !isLayoutXL && !secondaryText && styles.labelOnly
  ]);

  return (
    <div className={classes}>
      {labelContent}
      {secondaryText && (
        <TruncatingText
          size="sm"
          variant={isDisabled ? 'disabled' : 'secondary'}
          lineClamp={3}
          id={secondaryTextId}>
          {secondaryText}
        </TruncatingText>
      )}
    </div>
  );
};
